<template>
  <div class="location-delete mx-3 mb-3">
    <h2>Delete Project Location</h2>
    <div v-if="isManager">
      <p>
        Only managers can delete a location at this time. You must remove all
        observations from this location to delete it. This can either be done by
        changing each observation's location, or deleting each observation.
        There are currently
        <span class="font-weight-bold" v-if="!observationsIsLoading">{{
          observationsTotal
          }}</span><i v-else class="fa fa-spinner fa-spin mx-2"></i>
        observation<template v-if="observationsTotal !== 1">s</template> at this location.
      </p>
      <b-link class="btn btn-lg btn-dark mb-3" v-if="observationsTotal > 0 || observationsTotal === null" :to="{
        name: 'LocationObservations',
        params: { id: $route.params.id },
      }">
        View
        <span class="font-weight-bold" v-if="!observationsIsLoading">{{
          observationsTotal
          }}</span><i v-else class="fa fa-spinner fa-spin mx-2"></i> Observations
      </b-link>
      <p>
        This location is assigned to
        <b-link :to="{
          name: 'LocationAssignments',
          params: { id: $route.params.id },
        }">
          <span class="font-weight-bold" v-if="!assignmentsIsLoading">{{
            assignmentsTotal
            }}</span><i v-else class="fa fa-spinner fa-spin mx-2"></i> members or
          datasheets.
        </b-link>
        These will automatically be deleted along with the location, and will no
        longer be available for future observations.
      </p>

      <div class="btn btn-lg btn-danger" variant="danger" @click="deleteLocationClick()">
        <i class="fas fa-trash-alt"></i>
        Delete Location
      </div>
    </div>
    <div v-else>
      <p>You do not have permission to delete this location. Please contact your project managers for assistance.</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LocationDelete",
  props: {
    // Define props if needed
  },
  data() {
    return {
      // Component data
    };
  },
  computed: {
    ...mapGetters({
      location: "location/details",
      isManager: "location/isManager",
      observationsTotal: "location/observationsTotal",
      assignmentsTotal: "location/assignmentsTotal",
      observationsIsLoading: "location/observationsIsLoading",
      assignmentsIsLoading: "location/assignmentsIsLoading",
    }),
  },
  methods: {
    // Component methods
    ...mapActions({
      fetchObservations: "location/fetchObservations",
      fetchAssignments: "location/fetchAssignments",
      deleteLocation: "location/deleteLocation",
    }),
    deleteLocationClick() {
      const projectURL = this.location.project.urlField;
      this.deleteLocation(this.$route.params.id).then(() => {
        this.$router.push({
          name: "ProjectLocations",
          params: { id: projectURL },
        });
      });
    },
  },
  mounted() {
    // Fetch observations when the component is mounted
    this.fetchObservations();
    this.fetchAssignments();
  },
};
</script>

<style scoped>
.location-delete {
  /* Component styles */
}
</style>
